import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class UnvalidatedRecruiterCode {
  public readonly key = 'UnvalidatedRecruiterCode';

  constructor(
    public readonly value: string,
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean
  ) {}
}

export class InvalidRecruiterCode {
  public readonly key = 'InvalidRecruiterCode';

  constructor(
    public readonly value: string,
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean
  ) {}
}

export class ValidRecruiterCode {
  public static create(value: string, hasAhlAccess: boolean, hasNewYorkAccess: boolean) {
    return value?.length === 5
      ? new ValidRecruiterCode(value, hasAhlAccess, hasNewYorkAccess)
      : new InvalidRecruiterCode(value, hasAhlAccess, hasNewYorkAccess);
  }

  public readonly key = 'ValidRecruiterCode';
  private constructor(
    public readonly value: string,
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean
  ) {}
}

export type RecruiterCode = ValidRecruiterCode | InvalidRecruiterCode | UnvalidatedRecruiterCode;
export type RecruiterCodeOptions<TReturn> = ToMatchOptions<RecruiterCode, 'key', TReturn>;

export const isValidRecruiterCode = (recruiterCode: RecruiterCode): recruiterCode is ValidRecruiterCode =>
  recruiterCode.key === 'ValidRecruiterCode';

export const matchRecruiterCode = <TReturn>(
  recruiterCode: RecruiterCode,
  options: RecruiterCodeOptions<TReturn>
): TReturn => {
  switch (recruiterCode.key) {
    case 'InvalidRecruiterCode':
      return options.InvalidRecruiterCode(recruiterCode);
    case 'UnvalidatedRecruiterCode':
      return options.UnvalidatedRecruiterCode(recruiterCode);
    case 'ValidRecruiterCode':
      return options.ValidRecruiterCode(recruiterCode);
  }
};
